<script>
import resources from './resources'

export default {
  name: 'professional-graduations',
  mixins: [resources]
}
</script>

<template lang="pug">
  .row.border-top(style="margin-top: 10px; margin-bottom: 20px; width: 97%;")
    .col-xs-12.col-sm-4.margin-bottom
      small.grey Graduação
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.label }}

    .col-xs-12.col-sm-6.margin-bottom
      small.grey Instituição de Ensino
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.entity }}

    .col-xs-12.col-sm-2
      small.grey Ano
      br
      span#professionalName.blue(style="font-size: 15px;") {{ graduation.year }}
</template>
<style scoped>
.border-top {
  margin-top: 10px;
  margin-bottom: 20px;
  border-top: 1px solid rgb(221, 221, 221);
}
.grey {
  color: #93959b;
  font-weight: bold;
  font-size: 12px;
}
.blue {
    color: #2071b9;
    font-size: 1.2em;
    font-weight: 700;
    display: block;
}
.small {
    font-size: 90%;
}
</style>



// WEBPACK FOOTER //
// src/app/patient/profile-company/components/graduations/graduations.vue